module.exports = __webpack_public_path__ + "img/5.672232d3.png";